export class Category {
  constructor(
    public type: string,
    public codes : string[],
    public wording: string = ''
  ) {
  }
}
